<template>
  <SACModal
    modalClass="tech-action-modal"
    :cardClass="`tm-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionModalView === 'invite-tech'"
      #content
    >
      <InviteTechnician />
    </template>
    <template
      v-else-if="actionModalView === 'deactivate-tech'"
      #content
    >
      <DeactivateTechnicianConfirm />
    </template>
    <template
      v-else-if="actionModalView === 'reset-tech'"
      #content
    >
      <ResetTechnicianConfirm />
    </template>
    <template
      v-else-if="actionModalView === 'cancel-invite'"
      #content
    >
      <CancelTechnicianInvite />
    </template>
    <template
      v-else-if="actionModalView === 'edit-tech'"
      #content
    >
      <EditTechInfo />
    </template>
    <template
      v-else-if="actionModalView === 'bulk-tech'"
      #content
    >
      <BulkTechnician />
    </template>
    <template
      v-else-if="actionModalView === 'create-tech'"
      #content
    >
      <CreateTech />
    </template>
    <template
      v-else-if="actionModalView === 'reactivate-tech'"
      #content
    >
      <ReactivateTechnician />
    </template>
  </SACModal>
</template>
<script>
import technicianMixin from '@shared/mixins/technicianMixin';
import SACModal from '@shared/components/sac/SACModal.vue';
import InviteTechnician from './modal/InviteTechnician.vue';
import DeactivateTechnicianConfirm from './modal/DeactivateTechnicianConfirm.vue';
import ResetTechnicianConfirm from './modal/ResetTechnicianConfirm.vue';
import EditTechInfo from './modal/EditTechInfo.vue';
import CancelTechnicianInvite from './modal/CancelTechnicianInvite.vue';
import CreateTech from './modal/CreateTech.vue';
import BulkTechnician from './modal/BulkTechnician.vue';
import ReactivateTechnician from './modal/ReactivateTechnician.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    InviteTechnician,
    DeactivateTechnicianConfirm,
    ResetTechnicianConfirm,
    EditTechInfo,
    CancelTechnicianInvite,
    BulkTechnician,
    CreateTech,
    ReactivateTechnician,
  },
  mixins: [technicianMixin],
};
</script>
<style lang="scss">

.ac-input-container {
  flex: 1;
  margin-right: 12px;

  &:not(:last-child) {
    margin-bottom: 18px;
  }

  .ac-input-header {
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 3px;
  }
}

.tech-action-modal {
  .tm-invite-tech {
    width: 557px;
    height: 866px;
    max-height: 80vh;
  }

  .tm-deactivate-tech,
  .tm-reactivate-tech {
    width: 415px;
    height: 149px;
  }

  .tm-cancel-invite {
    width: 460px;
    height: 151px;
  }

  .tm-reset-tech {
    width: 557px;
    height: 350px;
  }

  .tm-edit-tech {
    width: 556px;
    height: 866px;
    max-height: 80vh;
  }

  .tm-bulk-tech {
    width: 800px;
    height: 560px;
  }

  .tm-create-tech {
    width: 80%;
    height: 520px;
    max-height: 80vh;
  }

  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;

    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-bottom: 0;
      overflow-y: auto;

      .ac-header {
        font-size: 1.25rem;
        font-weight: 600;
        margin-left: 12px;
      }

      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: $NBLUE20;
        }

        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }

    .ac-body-container {
      flex: 1;
      padding: 0 20px 20px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }

    .ac-error {
      color: $TOMATO100 !important;
      font-size: 0.875rem;
      font-weight: 500;
      padding-left: 4px;
      margin-top: 5px;
    }
  }

  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 12px;
    border-top: 0;

    button:not(:last-child) {
      margin-right: 12px;
    }

    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;

      &:hover {
        background-color: $NBLUE90;
      }

      &:disabled {
        background-color: $N50;
      }

      &:not(:last-child) {
        margin-left: 11px;
        background-color: $N50;
        color: $WHITE;

        &:hover {
          background-color: $N30;
        }
      }
    }

    .ac-form-cancel-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $TOMATO100;
      color: $WHITE;
      font-weight: 600;

      &:hover {
        background-color: $TOMATO200;
      }
    }
  }

  .ac-overlay {
    border-radius: 12px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
